import React, { createContext, useCallback, useContext, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

const ToastContext = createContext(() => {});

/**
 * App-wide toast for short "saved" / "failed" messages, instead of window.alert().
 * Wrap the app in <ToastProvider>, then: const toast = useToast(); toast('Saved'); toast('Failed', 'error');
 */
export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });

  const show = useCallback((message, severity = 'success') => {
    if (message) setToast({ open: true, message, severity });
  }, []);

  const close = (event, reason) => {
    if (reason !== 'clickaway') setToast((current) => ({ ...current, open: false }));
  };

  return (
    <ToastContext.Provider value={show}>
      {children}
      <Snackbar
        open={toast.open}
        autoHideDuration={6000}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={toast.severity} variant="filled" onClose={close} sx={{ width: '100%' }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
